export function generateNewProjectName(projectName: string) {
    // Регулярное выражение поиска постфикса вида (число)
    const regex = /(.*) \((\d+)\)$/;
    const match = projectName.match(regex);

    if (match) {
        // Если постфикс найден, увеличиваем число на 1
        const baseName = match[1];
        const number = parseInt(match[2], 10) + 1;
        return `${baseName} (${number})`;
    } else {
        // Если постфикс не найден, добавляем (2)
        return `${projectName} (2)`;
    }
}
